import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useCausesCondictionsChartsDataContext } from './hooks/useCausesCondictionsChartsDataContext';

export const PuerperiumDeath = () => {
    const { chartData } = useCausesCondictionsChartsDataContext();

    return (
        <SimpleBars
            title={'Morte Puerpério'}
            horizontal={true}
            subtitles={chartData?.puerperiumDeath?.map(
                (item) => item.description
            )}
            values={chartData?.puerperiumDeath?.map((item) => item.total || 0)}
            className="aligned-container"
        />
    );
};
